import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { Trash2 } from "lucide-react";

export const DeleteConfirmDialog = ({
  open,
  onOpenChange,
  onConfirm,
  onCancel,
  title = "Confirmar eliminación",
  message = "¿Está seguro de que desea eliminar este elemento? Esta acción no se puede deshacer.",
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-[#0F0F3D] border-[#1E1E5F] text-white max-w-md">
      <DialogHeader>
        <DialogTitle className="text-xl text-red-400 flex items-center gap-2">
          <Trash2 className="h-5 w-5" />
          {title}
        </DialogTitle>
      </DialogHeader>
      <div className="mt-4">
        <p className="text-slate-300">
          {message}
        </p>
      </div>
      <div className="flex justify-end gap-3 mt-6">
        <Button
          variant="outline"
          onClick={onCancel}
          className="border-[#1E1E5F] text-slate-300"
          data-testid="delete-confirm-cancel"
        >
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          className="bg-red-500 text-white hover:bg-red-600"
          data-testid="delete-confirm-submit"
        >
          <Trash2 className="h-4 w-4 mr-2" />
          Eliminar
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
